import { render, staticRenderFns } from "./PrizeElement.vue?vue&type=template&id=992cf18a&scoped=true&"
import script from "./PrizeElement.vue?vue&type=script&lang=js&"
export * from "./PrizeElement.vue?vue&type=script&lang=js&"
import style0 from "./PrizeElement.vue?vue&type=style&index=0&id=992cf18a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992cf18a",
  null
  
)

export default component.exports